import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ProductService } from 'src/app/_service/product.service';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { FormControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { FileuploadService } from 'src/app/_service/fileupload.service';
import { Whmis2015Service } from 'src/app/_service/whmis2015.service';
import { TreeComponent } from 'src/app/tree/tree.component';
import { Subject } from 'rxjs';
import { ManufacturerServerSearchComponent } from 'src/app/manufacturerServerSearch/manufacturerServerSearch.component';
import { FileuploadComponent } from 'src/app/fileupload/fileupload.component';
import { AuthService } from 'src/app/_service/auth.service';
import { LocationService } from 'src/app/_service/location.service';
import { ConfirmationDialogueComponent } from './inventoryConfirmation/confirmationDialogue/confirmationDialogue.component';
import { BrowserDetectorService } from 'src/app/_service/browserDetector.service';

@Component({
  selector: "inventory-detail",
  templateUrl: './inventory-detail.component.html',
  styleUrls: ['./inventory-detail.component.css']
})
export class InventoryDetailComponent implements OnInit {
  @ViewChild(FileuploadComponent, { static: true }) filepdf: FileuploadComponent;
  @ViewChild(ManufacturerServerSearchComponent, { static: true }) manufacturerSearch: ManufacturerServerSearchComponent;
  @ViewChild(TreeComponent, { static: true }) locationTree: TreeComponent;

  constructor(
    private productService: ProductService,
    private alertify: AlertifyService,
    public fb: FormBuilder,
    private dialog: MatDialog,
    private fileService: FileuploadService,
    private whmis2015Service: Whmis2015Service,
    private authService: AuthService,
    private locationService: LocationService,
    private cdr: ChangeDetectorRef,
    public detectBrowser: BrowserDetectorService,
    @Inject(MAT_DIALOG_DATA) public passedData: any
  ) {
    this.productEditForm = fb.group({
      productNameFormControl : new FormControl({value: '', disabled: true}),
      productAliasControl : new FormControl({value: '', disabled: true}),
      productCodeFormControl : new FormControl({value: '', disabled: true}),
      manufacturerFormControl : new FormControl({value: '', disabled: true}),
      additionalSuppliersFormControl : new FormControl({value: '', disabled: true}),

      creationDateFormControl : new FormControl({value: '', disabled: true}),
      
      mostRecentRequestFormControl : new FormControl({value: '', disabled: true}),
      
      lastModifiedDateFormControl : new FormControl({value: '', disabled: true}),

      lastVerifiedFormControl : new FormControl({value: '', disabled: true}),

      revisionDateFormControl : new FormControl({value: '', disabled: true}),

      registrationFormControl : new FormControl({value: '', disabled: true}),

      sdsOriginFormControl : new FormControl({value: '', disabled: true}),

      exemptionClassFormControl : new FormControl({value: '', disabled: true}),
      sdsFormatFormControl : new FormControl({value: '', disabled: true}),
      whmisExemptFormControl : new FormControl({value: '', disabled: true}),
      discontinuedFormControl : new FormControl({value: '', disabled: true}),

      sdsAvailabilityFormControl : new FormControl({value: '', disabled: true}),
      sdsHazardIdentificationFormControl : new FormControl({value: '', disabled: true}),
      notesFormControl : new FormControl({value: '', disabled: true}),

      hazardCategoryFormControl : new FormControl({value: '', disabled: true}),

      hmisHealthRatingFormControl : new FormControl({value: '', disabled: true}),
      hmisChronicRatingFormControl : new FormControl({value: '', disabled: true}),

      hmisFlammabilityRatingFormControl : new FormControl({value: '', disabled: true}),
      hmisReactivityFormControl: new FormControl({value: '', disabled: true}),

      nfpaHealthRatingsFormControl: new FormControl({value: '', disabled: true}),
      nfpaInstabilityFormControl: new FormControl({value: '', disabled: true}),
      nfpaSpecificFormControl: new FormControl({value: '', disabled: true}),
      nfpaFlammabilityFormControl: new FormControl({value: '', disabled: true}),
      iarcFormControl: new FormControl({value: '', disabled: true}),
      acgihFormControl: new FormControl({value: '', disabled: true}),

      transportHazardClassFormControl: new FormControl({value: '', disabled: true}),

      physicalStateFormControl: new FormControl({value: '', disabled: true}),

      physicalHazardClassFormControl: new FormControl({value: '', disabled: true}),

      healthHazardFormControl: new FormControl({value: '', disabled: true}),
      acuteToxicityRouteFormControl: new FormControl({value: '', disabled: true}),
      skinCorrosionRouteFormControl: new FormControl({value: '', disabled: true})
    });

    this.pictogramFormGroup = this.fb.group({
      pictograms: this.fb.array([])
    });
  }

  productEditForm: FormGroup;
  pictogramFormGroup: FormGroup;
  protected _onDestroy = new Subject<void>();

  confirmModal = false;
  productRemoved: any;

  manufacturers;
  selectedValue: any;
  selectedManufacturer: any;
  selectedManufacturerId: any;
  selectedMan: any;
  // tslint:disable-next-line: member-ordering
  selectedFileName: string = null;

  // tslint:disable-next-line: member-ordering
  selectedSDSOrigin: any;
  sdsOrigin: any;

  exemptionClass: any;
  selectedExemptionClass: any;

  categories: any;
  selectedCategories: any = [];

  hmisRatingshealth: any = [];
  selectedhmisRatingshealth: any = [];

  hmisRatingsChronic: any = [];
  selectedhmisRatingsChronic: any = [];

  hmisRatingsFlammability: any;
  selectedhmisRatingsFlammability: any;

  hmisRatingsReactivity: any;
  selectedhmisRatingsReactivity: any;

  nfpaRatingsHealth: any;
  selectednfpaRatingsHealth: any;

  nfpaRatingsInstability: any;
  selectednfpaRatingsInstability: any;

  nfpaRatingsSpecific: any;
  selectednfpaRatingsSpecific: any;

  nfparatingsFlammability: any;
  selectednfparatingsFlammability: any;

  iarc: any;
  selectedIarc: any = [];

  acgih: any;
  selectedacgih: any = [];

  transportHazard: any;
  selectedTransportHazard: any = [];

  physicalStates: any;
  selectedPhysicalStates: any = [];

  physicals: any;
  selectedPhysicalClass: any = [];

  healths: any;
  selectedHealthClass: any;
  acuteToxicity: any;
  skinCorrosionIrritation: any;

  acuteRoutes: any = [];
  skinRoutes: any = [];

  AcuteToxicityRoute: any;
  selectedAcuteToxicityRoute: any = [];

  SkinCorrosionIrritationRoute: any;
  selectedSkinCorrosionIrritation: any;

  pictograms: any = [];
  imageBind: any = [];
  pictogramValue: any = [];
  selectedCheckBoxes: any = [];

  productDetail: any = [];

  fileInfo: any = null;

  productId = this.passedData.product.productId;
  externalProductId: any;

  checkedNodes: any = null;
  timeForLocation: any;
  model: any = [];
  productAlias: any;

  sdsAvailability: any;
  sdsAvailabilityChecked: any;
  sdsHazardIdentification: any;

  updatemodel: any = {};
  updatedProductId: any;
  fileExistsCheck: any;
  isModified = false;

  sdsUserId: any;
  sdsUserIdNumber: number;

  formatValue: string;
  sdsFormat: SDSFormat[] = [
    {value: '1', viewValue: 'GHS'},
    {value: '2', viewValue: 'Other'}
  ];

  sdsFormatValue: string;
  MSDSFormatGroups: SDSFormatGroup[] = [
    {
      name: 'SDS Format',
      format: [
        {value: '1', viewValue: 'GHS'},
        {value: '2', viewValue: 'Other'}
      ]
    },
  ];

  exemptValue: string;
  whmisExempt: WhmisExempt[] = [
    {value: '0', viewValue: 'No'},
    {value: '1', viewValue: 'Yes'}
  ];

  discontinuedValue: string;
  discontinuedObj: Discontinued[] = [
    {value: '0', viewValue: 'No'},
    {value: '1', viewValue: 'Yes'}
  ];

  AcuteToxicityGroups: AcuteToxicityGroup[] = [
    {
      name: 'Acute toxity Route',
      status: [
        {value: '1', viewValue: 'Oral'},
        {value: '2', viewValue: 'Dermal'},
        {value: '3', viewValue: 'Inhalation'},
        {value: '4', viewValue: 'Unspecified'},
      ]
    },
  ];

  SkinCorrosionIrritationGroups: SkinCorrosionIrritationGroup[] = [
    {
      name: 'Skin corrosion / irritation Route',
      status: [
        {value: '1', viewValue: 'Skin'},
        {value: '2', viewValue: 'Eye'},
        {value: '3', viewValue: 'Respiratory'},
        {value: '4', viewValue: 'Ingestion'},
        {value: '3', viewValue: 'Unspecified'},
      ]
    },
  ];

  propagateChange = (_: any) => { };

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
emptyLocation: any = {};
  ngOnInit() {
    this.detectBrowser.DetectIE();
    this.getProdDetails();
    this.pictogramReferences();
    this.getSDSFiles();

    this.emptyLocation = this.locationTree.emptyLocation;
   // get userid for location tree (for site admins)
    this.sdsUserId = this.authService.decodedToken.userid;
    this.sdsUserIdNumber = +this.sdsUserId;
  }

show = false;
ngAfterViewChecked() {
    const show = this.validateFormControl(this.productEditForm);
    if (show != this.show) {
      this.show = show;
      this.cdr.detectChanges();
    }
  }


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
    }


    public validateFormControl(control) {
      if (control.status === 'VALID') {
        return true;
      } else {
        return false;
      }
    }

    onSDSAvailabilityChecked($event) {
      console.log($event.checked);
      if ($event.checked) {
        this.sdsAvailabilityChecked = 1;
      } else {
        this.sdsAvailabilityChecked = 0;
      }
    }

    hazardIdentification($event) {
      console.log($event.checked);
      if ($event.checked) {
        return this.sdsHazardIdentification = 1;
      } else {
        this.sdsHazardIdentification = 0;
      }
    }

    locationValidator(locationTreeId) {
      if (locationTreeId !== undefined) {
        for (const locationId of locationTreeId.checklistSelection._selection) {
          if (locationId.authorityUnitId !== undefined) {
            return true;
          } else {
            return false;
          }
        }
      }
    }

    openConfirmationDialog() {
        const dialogRef = this.dialog.open(ConfirmationDialogueComponent, {
          width: '400px',
          height: '300px'
        });
        // dialogRef.disableClose = true;
        dialogRef.afterClosed().subscribe(result => {
          // do something...confirm with Yulia
        });
    }

   // get pdf file
   getSDSFiles() {
    const propId = this.productId;
    const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, {type: contentType});
      return blob;
    };
    const blobToFile = (theBlob: Blob, fileName: string): File => {
      const b: any = theBlob;
      b.lastModifiedDate = new Date();
      b.name = fileName;
      return b as File;
    };

    return this.fileService.DownloadFile(propId).subscribe(res => {
      if (res == null) { return; }
      this.fileInfo = res;
      const contentType = 'application/pdf';
      const blob = b64toBlob(this.fileInfo.base64File, contentType);
      const blobUrl = URL.createObjectURL(blob);
      const bfile = blobToFile(blob, this.fileInfo.fileName);
      console.log(this.filepdf);
      this.filepdf.files.push(bfile);
      this.filepdf.fileUrl = blobUrl;
      this.filepdf.checkedTime = 0;
    });
  }

  getProdDetails() {
    return this.productService.getAdminProductDetails(this.productId).pipe(takeUntil(this._onDestroy))
    .subscribe(res => {
      this.productDetail = res[0];
      console.log(this.productDetail);
      this.externalProductId = this.productDetail.externalProductId;
      this.imageBind = this.productDetail.pictogram;
      this.sdsFormatValue = this.productDetail.sdsFormat === 4 ? ('1') : ('2');
      this.discontinuedValue = this.productDetail.discontinued === false ? ('0') : ('1');
      this.productAlias = this.productDetail.productAlias;
      this.sdsAvailability = this.productDetail.sdsAvailability === false ? (false) : (true);
      this.productEditForm.get('sdsAvailabilityFormControl').setValue(this.sdsAvailability);
      this.sdsHazardIdentification = this.productDetail.sdsHazardIdentification === false ? (false) : (true);
      this.productEditForm.get('sdsHazardIdentificationFormControl').setValue(this.sdsHazardIdentification);
      this.exemptValue = this.productDetail.whmisExempt === false ? ('0') : ('1');
      this.selectedExemptionClass = this.productDetail.exemptionClass;
      this.selectedSDSOrigin = this.productDetail.sdsOrigin;
      this.selectedPhysicalClass = this.productDetail.physicalHazardClass;
      this.selectedHealthClass = this.productDetail.healthHazardClass;
      this.timeForLocation = setInterval(() => { this.getLocationTree(); }, 10);
    });
  }

  pictogramReferences() {
    return this.whmis2015Service.getPictograms().subscribe(res => {
      this.pictograms = res;
      console.log(this.pictograms);
    });
  }

  isChecked(id) {
    return (this.imageBind.find(x => x === id) == null) ? false : true;
  }

  checkedBoxes(id) {
    return (this.imageBind.find(x => x == id) == null) ? 'grayscale(100%)' : 'none';
  }

  onChangePictogram($event) {
    const pictograms = <FormArray>this.pictogramFormGroup.get('pictograms') as FormArray;
    this.pictogramValue = pictograms;
    this.selectedCheckBoxes = $event.source.value;
    console.log(this.selectedCheckBoxes);
    if ($event.checked) {
      pictograms.push(new FormControl($event.source.value));
    } else {
      const i = pictograms.controls.findIndex(x => x.value === $event.source.value);
      pictograms.removeAt(i);
    }
    this.imageBind = pictograms.value;
  }

  getLocationTree() {
    if (this.locationTree.location.length === 0) { return; }
    this.checkedNodes = [];
    console.log(this.locationTree.location);
    for (const node of this.locationTree.location) {
      this.markLocations(node, 0);
    }
    clearInterval(this.timeForLocation);
    this.locationTree.checklistSelection.select(...this.checkedNodes);
    
    this.checkedNodes.forEach(node => {
      this.expandParents(node);
    });
  }

  expandParents(node: any) {
    let parent = this.locationTree.getParentNode(node);
    while (parent) {
      this.locationTree.treeControl.expand(parent);
      parent = this.locationTree.getParentNode(parent);
    }
  }

  markLocations(node: any, level: number) {
    if (this.productDetail.locationId.indexOf(node.authorityUnitId) > -1) {
      const flat = this.locationTree.transformer(node, level);
      this.locationTree.treeControl.expand(flat);
      this.checkedNodes.push(flat);
    }
    if (node.children != null && node.children.length > 0) {
      for (const chd of node.children) {
        this.markLocations(chd, level + 1);
      }
    }
  }

  testtesttest = false;
  moveToSelectedTab(tabName: string) {
    for (let i = 0; i < document.querySelectorAll('.mat-tab-label-content').length; i++) {
      if (!this.productEditForm.invalid) {
        this.testtesttest = true;
        if ((<HTMLElement>document.querySelectorAll('.mat-tab-label-content')[i]).innerText == tabName) {
          (<HTMLElement>document.querySelectorAll('.mat-tab-label')[i]).click();
        }
      } else {
        this.testtesttest = false;
        return null;
      }
      }
  }

  contactOHSSupport: any = {};

  updateLocations() {
     // site admin location tree/location ID
     if (this.authService.decodedToken.role === 'Site Admin') {
      this.updatemodel.LocationId = [];
      for (const loc of this.locationTree.checklistSelection.selected) {
        if (loc.userId === this.sdsUserIdNumber) {
          this.updatemodel.LocationId.push(loc.authorityUnitId);
        }
      }
    }

    return this.locationService.updateLocation(this.productId, this.updatemodel).subscribe(res => {
      this.contactOHSSupport = res.headers.get('contactOHSSupport');
      if (this.contactOHSSupport) {
        this.openConfirmationDialog();
        this.isModified = false;
      } else {
        this.isModified = true;
        this.alertify.success('Product has been added to your location(s)');
      }
    }, error => {
      this.alertify.error('Something went wrong, please try again');
    });
  }

}


export interface SDSFormat {
  value: string;
  viewValue: string;
}

export interface SDSFormatGroup {
  disabled?: boolean;
  name: string;
  format: SDSFormat[];
}

export interface WhmisExempt {
  value: string;
  viewValue: string;
}

export interface Discontinued {
  value: string;
  viewValue: string;
}

export interface AcuteToxicity {
  value: string;
  viewValue: string;
}

export interface AcuteToxicityGroup {
  disabled?: boolean;
  name: string;
  status: AcuteToxicity[];
}

export interface SkinCorrIrritation {
  value: string;
  viewValue: string;
}

export interface SkinCorrosionIrritationGroup {
  disabled?: boolean;
  name: string;
  status: SkinCorrIrritation[];
}

export class UpdateProductModel {
  ProductName: string;
  ProductAlias: string;
  ProductCode: string;
  ManufacturerId: number;
  AdditionalSuppliers: string;
  CreationDate: string;
  LastModified: string;
  LastVerified: string;
  RevisionDate: string;
  RegistrationNumber: string;
  SDSOrigin: any;
  ExemptionClass: any;
  SDSFormat: any;
  WHMISExempt: any;
  Discontinued: any;
  Pictogram: any;
  Notes: string;
  HazardCategoryId: any;
  HMISHealthRatings: any;
  HMISChronicRatings: any;
  HMISFlammabilityRatings: any;
  HMISReactivityRatings: any;
  NFPAHealthRatings: any;
  NFPAInstabilityRatings: any;
  NFPASpecificRatings: any;
  NFPAFlammabilityRatings: any;
  IARC: any;
  ACGIH: any;
  TransportHazardClass: any;
  PhysicalState: any;
  PhysicalHazardClass: any;
  HealthHazardClass: any;
  AcuteToxRoute: any;
  SkinIrrCorrRoute: any;
  FileName: string;
  LocationId: any;
}
